export function getOwner(workspace) {
  if (!workspace) return {}
  return workspace?.memberCollection?.items?.find(
    (member) => member.role === 'owner'
  )?.user
}
